import React, { useState } from 'react'
import {
    Grid,
    Card,
    CardContent,
    CardActions,
    Typography,
    Button,
    IconButton,
    Tooltip,
    Dialog,
    DialogActions,
    DialogContent,
} from '@material-ui/core';
import { CheckCircle, FindReplace, Delete, Flag } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from "notistack";
import axios from "axios";
import ImageContainer from "../pages/ImageContainer";

const useStyles = makeStyles({
    root: {
        minWidth: 300,
        marginBottom: 100,
    },
    cards: {
        marginTop: 50,
        marginLeft: 25,
    }
});

const TaskCard = (props) => {
    const [openDelete, setOpenDelete] = useState(false);
    const [tbDeleted, setTBDeleted] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const { image, index, handleAnnotate, handleViewAnnotation, handleResponse, getImages, flags } = props;
    const imageId = image.imageKey.split('/').pop().split('.')[0];
    const classes = useStyles();
    const handleDeleteDialog = (key) => {
        setTBDeleted(key);
        setOpenDelete(true);
    };
    const handleCloseDelete = () => {
        setTBDeleted('');
        setOpenDelete(false);
        getImages();
    };
    async function deleteImage() {
        try {
            const response = await axios.post("/api/benchmarks/images/delete", {
                imageKey: tbDeleted,
            });
            if (response && response.data) {
                enqueueSnackbar(response.data, {
                    variant: "success",
                });
                handleCloseDelete();
            }
        } catch (e) {
            enqueueSnackbar('Could not delete image', {
                variant: "error",
            });
        }
    }
    return (
        <>
            <Grid container item sm={12} md={3} spacing={2} key={index}>
                <Card className={classes.root}>
                    <div>
                        <CardContent>
                            <Typography variant='h5' color="textSecondary" gutterBottom>
                                Image ID: {imageId}
                                <Tooltip style={{ float: 'right' }} title="Delete">
                                    <IconButton
                                        onClick={() => handleDeleteDialog(image.imageKey)}
                                    >
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                                {image.ocr ? <Tooltip style={{ float: 'right' }} title="OCR Ready">
                                    <IconButton>
                                        <CheckCircle style={{ color: "green" }} />
                                    </IconButton>
                                </Tooltip> : <Tooltip style={{ float: 'right' }} title="OCR Pending">
                                    <IconButton>
                                        <FindReplace style={{ color: "orange" }} />
                                    </IconButton>
                                </Tooltip>}
                            </Typography>
                            <ImageContainer
                                src={image.imageKey}
                                category='benchmark'
                            />
                        </CardContent>
                    </div>
                    <div>
                        <CardActions style={{ display: 'block' }}>
                            <br />
                            {image.annotation ? (
                                <Button
                                    size='large'
                                    onClick={() => handleViewAnnotation(image.imageKey)}
                                >
                                    View Annotation
                                </Button>
                            ) : (
                                <Button
                                    size='large'
                                    onClick={() => handleAnnotate(image.imageKey)}
                                    disabled={!image.ocr}
                                >
                                    Annotate
                                </Button>
                            )}
                            {flags[imageId] && flags[imageId].annotation && flags[imageId].annotation === true ?
                                <Flag style={{ color: "orange", float: 'right', font: '20px' }} /> : ''
                            }
                            <br />
                            <Button
                                size='large'
                                onClick={() => handleResponse(image.imageKey)}
                                disabled={!image.inference}
                            >
                                View Response
                            </Button>
                            {flags[imageId] && flags[imageId].response && flags[imageId].response === true ?
                                <Flag style={{ color: "red", float: 'right', font: '20px' }} /> : ''
                            }
                        </CardActions>
                    </div>
                </Card>
            </Grid>
            <Dialog open={openDelete} onClose={handleCloseDelete} aria-labelledby="delete">
                <DialogContent>
                    Are you sure you want to delete ?
                </DialogContent>
                <DialogActions>
                    <Button onClick={deleteImage} variant="contained" color="secondary">
                        Yes
                    </Button>
                    <Button onClick={handleCloseDelete} variant="contained" color="default">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TaskCard;